/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import CloseIcon from 'DesignSystem/Svgs/CloseIcon/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/CloseAction",
  isSubmitting
  
}) {
let moveResourcesIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'move_resources',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="move_resources"
 disabled={moveResourcesIsSubmittingData}
 onClick={onClick}
 type="secondary"
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<CloseIcon
{...childProps}
  viewPath={`${viewPath}/CloseIcon`}
/>
)}
</TysiaButtonIcon>
<Shortcut
{...childProps}
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onClick={onClick1}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}